import React, { useEffect, useState } from 'react';
import { RBHBox, RBHButton, RBHImage, RBHText, RBHTextPasswordInput } from '../../../shared/components';
import styles from './styles';
import { Form } from 'antd';
import { Fonts, Images } from '../../../shared/theme';
import CommonStyle from '../../../shared/theme/common-style';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AuthHelper } from '../../auth-helper';
import { authSagas } from '../../auth-saga';
import { AUTH_LOCAL_STORAGE_KEY, AUTH_REQUEST_ID_LIST, COGNITO_CHALLENGE } from '../../auth-constant';
import { CommonValidator, httpCreators } from 'rbh-merchant-core';
import { CheckCircleOutlined } from '@ant-design/icons';
import { authCreators } from '../../auth-action';
import styleText from '../../../shared/components/rbh-text/styles';
import './styles.css';
import { AUTH_STATE_KEY, authStateSelector } from '../../auth-reducer';
import { AuthService } from '../../auth-services';
import { Base64 } from 'js-base64';
import { getLocalStorage } from '../../../shared/helpers/utility';

export const ResetScreen: React.FC<Props> = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const history = useHistory();
  const [form] = Form.useForm();
  const [formInvalid, setFormInvalid] = useState(true);
  const session = useSelector(authStateSelector(AUTH_STATE_KEY.SESSION));
  const dispatch = useDispatch();

  const goToLogin = () => {
    dispatch(authCreators.setAuthState(AUTH_STATE_KEY.SESSION, undefined));
    history.goBack();
  };

  useEffect(() => {
    dispatch(authCreators.setAuthState(AUTH_STATE_KEY.STATUS, undefined));
    if (!session) {
      goToLogin();
    }
  }, []);

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (values[key] === undefined || values[key] === '') {
        invalid = true;
        break;
      }
    }
    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const stateIsSuccess = () => {
    dispatch(authCreators.setAuthState(AUTH_STATE_KEY.SESSION, undefined));
    setIsSuccess(true);
  };

  const onFinishPassword = (values: any) => {
    const username = getLocalStorage(AUTH_LOCAL_STORAGE_KEY.EMAIL) as string;
    dispatch(httpCreators.request({
      service: AuthService.setNewPassword,
      serviceParams: {
        challengeName: COGNITO_CHALLENGE.NEW_PASSWORD_REQUIRED,
        session,
        username,
        password: Base64.encode(values.confirmPassword),
      },
      id: AUTH_REQUEST_ID_LIST.CONFIRM_NEW_PASSWORD,
      sagaHandler: authSagas.confirmNewPasswordHandle,
      callbackParams: stateIsSuccess
    }));
  };

  const successBox = () => {
    return (
      <RBHBox style={styles.successBox}>
        <RBHBox style={styles.contentModal}>
          <RBHBox style={styles.successIconBox}>
            <CheckCircleOutlined id={'icon_success'} translate={null} style={styles.successIconImage} />
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHText id={'success_title'} style={Fonts.style.textHeaderKanitMediumFakeBlack}>
              <FormattedMessage id={'main.setnewpassword.successbox.title'} />
            </RBHText>
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTop}>
            <RBHText id={'success_description'} style={Fonts.style.textDescription}>
              <FormattedMessage id={'main.setnewpassword.successbox.description'} />
            </RBHText>
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHButton id={'success_button'} style={styles.buttonBox} onClick={goToLogin}>
              <FormattedMessage id={'main.setnewpassword.successbox.button'} />
            </RBHButton>
          </RBHBox>
        </RBHBox>
      </RBHBox>
    );
  };

  const resetPasswordBox = () => {
    return (
      <RBHBox style={styles.resetPassword_Box}>
        <RBHBox style={{ padding: 40 }}>
          <RBHBox style={styles.iconBox}>
            <RBHImage style={styles.iconImage} src={Images.logoIcon} />
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <RBHText id={'resetpassword_title'} style={Fonts.style.headerFakeBlack}>
              <RBHImage style={styles.iconBack} src={Images.back} onClick={goToLogin} />
              <FormattedMessage id={'main.setnewpassword.title'} />
            </RBHText>
          </RBHBox>
          <RBHBox style={CommonStyle.paddingTopLarge}>
            <Form size='small' form={form} style={styleText.formText}
              onFieldsChange={checkFormInvalid} onFinish={onFinishPassword}>

              <Form.Item colon={false} name='newPassword' validateTrigger={['onChange', 'onBlur']}
                label={<FormattedMessage id={'main.setnewpassword.form.newpassword.title'} />}
                rules={[
                  {
                    pattern: /^.{8,}$/,
                    message: <FormattedMessage id={'main.setnewpassword.form.error.formatpassword'} />
                  },
                  ({ getFieldValue }) => ({
                    validator(_, formValue) {
                      if (formValue === getFieldValue('confirmPassword') ||
                        formValue !== getFieldValue('confirmPassword')) {
                        form.validateFields(['confirmPassword']);
                      }
                      return Promise.resolve();
                    }
                  })
                ]}>
                <RBHTextPasswordInput
                  id='newPassword'
                  placeholder={'main.setnewpassword.form.newpassword.placeholder'}
                  autoComplete='new-password'
                  onBlur={() => trimFieldValue('newPassword')}
                  maxLength={CommonValidator.Password.maxLength}
                />
              </Form.Item>

              <Form.Item colon={false} name='confirmPassword' validateTrigger={['onChange', 'onBlur']}
                label={<FormattedMessage id={'main.setnewpassword.form.confirmpassword.title'} />}
                rules={[
                  {
                    pattern: /^.{8,}$/,
                    message: <FormattedMessage id={'main.setnewpassword.form.error.formatpassword'} />
                  },
                  ({ getFieldValue }) => ({
                    validator(_, formValue) {
                      if (!formValue) {
                        return Promise.resolve();
                      }
                      else if (getFieldValue('newPassword') === formValue) {
                        return Promise.resolve();
                      }
                      else if (formValue !== getFieldValue('newPassword')) {
                        return Promise.reject(<FormattedMessage id={'main.setnewpassword.form.error.samepassword'} />);
                      }
                      return Promise.resolve();
                    }
                  })
                ]}>
                <RBHTextPasswordInput
                  id='confirmPassword'
                  placeholder={'main.setnewpassword.form.confirmpassword.placeholder'}
                  autoComplete='off'
                  onBlur={() => trimFieldValue('confirmPassword')}
                  maxLength={CommonValidator.Password.maxLength}
                />
              </Form.Item>

              <RBHButton
                id={'resetPassword_button'}
                style={styles.buttonBox}
                disabled={formInvalid}
                type='primary'
                htmlType='submit'>
                <FormattedMessage id={'main.setnewpassword.form.confirmpassword.button'} />
              </RBHButton>
            </Form>
          </RBHBox>
        </RBHBox>
      </RBHBox>
    );
  };

  return (
    <RBHBox style={styles.reset_layout}>
      <RBHBox style={styles.resetPassword_content}>
        {isSuccess ? successBox() : resetPasswordBox()}
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
